export default {
  plannedActions: {
    header: {
      notes:
        'Header for the planned actions accordion on the activity selection details pane',
      message: 'Planned actions',
    },
    actionType: {
      measure: {
        notes:
          'Row label for actions of type measure in the planned actions table',
        message: 'Measurement',
      },
      replace: {
        notes:
          'Row label for actions of type replace in the planned actions table',
        message: 'Replace',
      },
    },
    plannedValue: {
      measure: {
        notes:
          'Value shown in the planned column when a measure action is planned',
        message: 'Measure',
      },
    },
    editActions: {
      replaceWithSame: {
        notes:
          'Option in the replace row edit dropdown that plans replacements using the same screening media as initially installed',
        message: 'Replace with same',
      },
      replaceWithDifferent: {
        notes:
          'Option in the replace row edit dropdown that opens the screening media selection dialog',
        message: 'Replace with different...',
      },
    },
  },
};
